export enum AiUploadStatus {
  Processing = 1,
  Completed = 2,
}

export class AiUploadHistory {
  id: number;
  guid: string;
  date: string;
  status: string;
  uploadedCount: number;
  maxCount: number;
  processedCount: number;
  maxProcessedCount: number;
  uploadProgressBarWidth: number;
  processProgressBarWidth: number;
  uploadStatus: string;
  processingStatus: string;
  completedEntities: number;

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.guid = data?.guid ?? '';
    this.date = data?.date ?? '';
    this.status = data?.status ?? '';
    this.uploadedCount = data?.uploadedCount ?? 0;
    this.maxCount = data?.maxCount ?? 0;
    this.processedCount = data?.processedCount ?? 0;
    this.maxProcessedCount = data?.maxProcessedCount ?? 0;
    this.uploadProgressBarWidth = data?.uploadProgressBarWidth ?? 0;
    this.processProgressBarWidth = data?.processProgressBarWidth ?? 0;
    this.uploadStatus = data?.uploadStatus ?? '';
    this.processingStatus = data?.processingStatus ?? '';
    this.completedEntities = data?.completedEntities ?? 0;
  }
}

export class AiUploadHistoryStats {
  uploadedEntriesSum: number;
  completedEntriesSum: number;
  processedEntriesSum: number;

  constructor(data?: any) {
    this.uploadedEntriesSum = data?.uploadedEntriesSum ?? 0;
    this.completedEntriesSum = data?.completedEntriesSum ?? 0;
    this.processedEntriesSum = data?.processedEntriesSum ?? 0;
  }
}
